// ---------------------------------------------------------------------------
// Shared truncation helper for consistent text clipping with tooltip support
// ---------------------------------------------------------------------------

/** Default character cap for device names in tables and panels. */
export const TRUNCATE_DEVICE_NAME = 24;

/** Default character cap for media titles in tables and lists. */
export const TRUNCATE_MEDIA_TITLE = 40;

/** Default character cap for series names in cards and panels. */
export const TRUNCATE_SERIES_NAME = 32;

export interface TruncateResult {
  /** The text to render (clipped with ellipsis when truncated). */
  displayText: string;
  /** Whether the text was clipped. */
  wasTruncated: boolean;
  /** The original, unclipped text (for tooltip / aria-label). */
  fullText: string;
}

/**
 * Truncate `text` to at most `maxChars` characters.
 *
 * When truncated the display string is `text.slice(0, maxChars - 1) + "\u2026"`.
 * Handles null / undefined gracefully (returns empty string, `wasTruncated: false`).
 */
export function truncateText(
  text: string | null | undefined,
  maxChars: number,
): TruncateResult {
  const safe = text ?? "";

  if (safe.length <= maxChars) {
    return { displayText: safe, wasTruncated: false, fullText: safe };
  }

  return {
    displayText: safe.slice(0, maxChars - 1) + "\u2026",
    wasTruncated: true,
    fullText: safe,
  };
}
